require([
	'legacy/yui-2.9.0-combo',
	'legacy/data-TEMP',
	'legacy/liveperson/hotfix',
	'legacy/formutil',
	'legacy/navigation',
	'legacy/ie7',
	'legacy/pw',
	'legacy/loyalty',
	'legacy/reg',
	'legacy/resize',
	'legacy/timecountdown',
	'legacy/accountlimitations/accountlimitations',
	'legacy/referafriend/referafriend',
	'legacy/mypages/feedAnimation',
	'legacy/pp/shop',
	'legacy/bonus/bonus',
	'legacy/bonus/bonusChecks',
	'legacy/campaign/campaign',
	'legacy/old-shade',
	'legacy/support/support',

	// TODO: needed for relogin.jsp (at least) because of old code. Reimplement relogin
	'all/player/login'

], function () {
	'use strict';
	// TODO: these handle old legacy pages initialization instead of $() or similar
	// TODO: work away them all
	$(function () {
		if (typeof init === 'function') {
			init();
		}
		if (typeof doInit === 'function') {
			doInit();
		}
	});

});

define("legacy", function(){});

